import React from "react";

const ConfirmModal = ({
  isOpen,
  title = "Confirm Update",
  message = "Are you sure you want to update?",
  onCancel,
  onConfirm,
  confirmText = "Yes, Update",
  cancelText = "No",
  loading = false,
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div  style={{ backgroundColor: "rgba(0, 0, 0, 0.3)" }} className="fixed inset-0 z-50 flex items-center justify-center ">
      <div className="w-full max-w-md mx-4 bg-white rounded-lg shadow-xl dark:bg-gray-800">
        {/* Header */}
        <div className="px-6 py-4  border-gray-200 border-1 dark:border-gray-700">
          <h3 className="text-lg font-semibold text-center text-gray-800 mt-3 dark:text-gray-100">
            {title}
          </h3>
        </div>

        {/* Message */}
        <div className="px-6 py-5">
          <p className="text-sm text-gray-600 dark:text-gray-300 text-center">{message}</p>
        </div>

        {/* Buttons */}
        <div className="flex justify-end gap-3 px-6 py-4 b border-gray-200 dark:border-gray-700">
          {/* No */}
          <button
            type="button"
            onClick={onCancel}
            disabled={loading}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 disabled:opacity-50 dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600"
          >
            {cancelText}
          </button>

          {/* Yes, Update */}
          <button
            type="button"
            onClick={onConfirm}
            disabled={loading}
            className="px-4 py-2 text-sm font-medium text-white bg-green-500 rounded-md hover:bg-green-600 disabled:opacity-50"
          >
            {loading ? "Processing..." : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
